var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8354 21.2769H16.6135V14.9898H18.6697C19.1911 14.9898 19.4992 14.3973 19.1911 13.9706L15.1913 8.4361C14.9365 8.08056 14.4091 8.08056 14.1543 8.4361L10.1545 13.9706C9.8464 14.3973 10.1486 14.9898 10.676 14.9898H12.7322V21.2769H5.76364C2.65269 21.1051 0.175781 18.1956 0.175781 15.0432C0.175781 12.8685 1.35498 10.9723 3.10304 9.94713C2.94305 9.51456 2.86009 9.05237 2.86009 8.56646C2.86009 6.34436 4.65555 4.54889 6.87766 4.54889C7.35764 4.54889 7.81984 4.63185 8.25241 4.79184C9.53827 2.06606 12.3115 0.175781 15.535 0.175781C19.7066 0.181707 23.1435 3.37562 23.5346 7.44652C26.7404 7.9976 29.1758 10.9663 29.1758 14.3262C29.1758 17.9171 26.3789 21.0281 22.8354 21.2769Z",
    fill: "#B3B7BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.420d21b2779be96d1ada5476c3db135c.svg";
export { ForwardRef as ReactComponent };